export enum LocalStorageKey {
  // UI State keys (not part of VenueData)
  LOGIN = 'login',
  VENUE = 'venue',
  PLAN = 'plan',
  REVIEW_VENUE = 'REVIEW_VENUE',
  ANONYMOUS_UID = 'anonymousUid',
  // Stashed at submit time for the confirmation page copy — the session doc
  // (and its venueName/userEmail) is deleted as part of submission cleanup.
  CONFIRMED_VENUE_NAME = 'confirmedVenueName',
  CONFIRMED_EMAIL = 'confirmedEmail',
  FUNNEL_START_TIME = 'funnelStartTime',
  FUNNEL_FURTHEST_STEP = 'funnelFurthestStep',
  FUNNEL_COMPLETED = 'funnelCompleted',

  // Campaign attribution (first-touch UTM parameters)
  UTM_SOURCE = 'utmSource',
  UTM_MEDIUM = 'utmMedium',
  UTM_CAMPAIGN = 'utmCampaign',
  UTM_TERM = 'utmTerm',
  UTM_CONTENT = 'utmContent',

  // Auth keys (not part of VenueData)
  AGREE_TERMS = 'agreeTerms',

  // VenueData keys - these match VenueData field names exactly
  VENUE_NAME = 'venueName',
  VENUE_CATEGORY_TYPE = 'venueCategoryType',
  VENUE_TYPE = 'venueType',
  SELECTED_PLAN = 'selectedPlan',
  BILLING_FREQUENCY = 'billingFrequency',
  USER_EMAIL = 'userEmail',
  USER_LOCALE = 'userLocale',
  CONTACT_PERSON = 'contactPerson',
  CONTACT_PHONE_NUMBER = 'contactPhoneNumber',
  CONTACT_EMAIL = 'contactEmail',
  STREET_ADDRESS = 'streetAddress',
  CITY = 'city',
  STATE_PROVINCE = 'stateProvince',
  POSTAL_CODE = 'postalCode',
  COUNTRY = 'country',
  INTERNET_AVAILABILITY = 'internetAvailability',

  // Venue profile keys - session doc only, not part of VenueData
  NONPROFIT_STATUS = 'nonprofitStatus',
  MONTHLY_ORDER_VOLUME = 'monthlyOrderVolume'
}

// Keys that map directly to VenueData fields
export const VENUE_DATA_KEYS: LocalStorageKey[] = [
  LocalStorageKey.VENUE_NAME,
  LocalStorageKey.VENUE_CATEGORY_TYPE,
  LocalStorageKey.VENUE_TYPE,
  LocalStorageKey.SELECTED_PLAN,
  LocalStorageKey.BILLING_FREQUENCY,
  LocalStorageKey.USER_EMAIL,
  LocalStorageKey.USER_LOCALE,
  LocalStorageKey.CONTACT_PERSON,
  LocalStorageKey.CONTACT_PHONE_NUMBER,
  LocalStorageKey.CONTACT_EMAIL,
  LocalStorageKey.STREET_ADDRESS,
  LocalStorageKey.CITY,
  LocalStorageKey.STATE_PROVINCE,
  LocalStorageKey.POSTAL_CODE,
  LocalStorageKey.COUNTRY,
  LocalStorageKey.INTERNET_AVAILABILITY
];
